import FizConfig from "../../FizConfig.js";
import loadImage from "./load-image.js";
import "./load-image-meta.js";
import "./load-image-scale.js";
import "./load-image-exif.js";
import "./load-image-exif-map.js";
import "./load-image-orientation.js";
  
export {thumbnail,downsize}

var 
  //comment to disable logs
  console = {log:function(){}},
  videoSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M46.8 37.8v124.4a7.7 7.7 0 0 0 7.6 7.8h91a7.7 7.7 0 0 0 7.8-7.6v-102L122.8 30H54.5a7.7 7.7 0 0 0-7.7 7.6Z" fill="#64bda6"/><path d="M61.5 142.5h3.4l3.5 10.1.6 2.2h.2l.6-2.2 3.7-10h3.4l-6.1 16.7h-3.4Zm18.5 0h3.2v16.8H80Zm7.7 0h5.7a10 10 0 0 1 3.6.6 7.7 7.7 0 0 1 2.7 1.8 7.5 7.5 0 0 1 1.7 2.6 10.2 10.2 0 0 1 0 6.9 7.5 7.5 0 0 1-1.7 2.6 7.8 7.8 0 0 1-2.7 1.7 10 10 0 0 1-3.6.6h-5.7Zm5.6 13.8a7 7 0 0 0 2.4-.4 4.8 4.8 0 0 0 1.8-1 4.4 4.4 0 0 0 1-1.7 6.5 6.5 0 0 0 .3-2.3 6.5 6.5 0 0 0-.3-2.2 4.4 4.4 0 0 0-1-1.7 4.8 4.8 0 0 0-1.8-1 7.3 7.3 0 0 0-2.4-.5h-2.4v10.8Zm15.7-10.8v4h6.7v3H109v3.8h7.5v3h-10.7v-16.8h10.6v3Zm19 14.2a8.9 8.9 0 0 1-3.5-.7 8.5 8.5 0 0 1-4.6-4.6 9 9 0 0 1 1.8-9.7 8.5 8.5 0 0 1 2.8-1.9 9.3 9.3 0 0 1 7 0 8.5 8.5 0 0 1 2.8 1.9 8.6 8.6 0 0 1 1.8 2.8 9.2 9.2 0 0 1 0 6.9 8.6 8.6 0 0 1-1.8 2.8 8.7 8.7 0 0 1-2.8 1.8 9 9 0 0 1-3.5.7Zm0-3a5.8 5.8 0 0 0 2.2-.4 5.5 5.5 0 0 0 1.8-1.2 5.3 5.3 0 0 0 1.2-1.8 6.7 6.7 0 0 0 0-4.7 5.3 5.3 0 0 0-1.2-1.8 5.7 5.7 0 0 0-8 0 5.3 5.3 0 0 0-1.2 1.8 6.7 6.7 0 0 0 0 4.7 5.3 5.3 0 0 0 1.2 1.8 5.5 5.5 0 0 0 1.8 1.2 5.7 5.7 0 0 0 2.2.4Z" fill="#fff"/><path fill="#46a38a" d="M46.8 131.9h106.5v3.3H46.8zm106.4-71.4L122.8 30h-.2l-4.2 29.2a6.8 6.8 0 0 0 6.9 6.8l28-5.3Z"/><path d="M153.2 60.5h-25a5.5 5.5 0 0 1-5.4-5.5V30Z" fill="#fff" opacity=".8"/><path d="M69.6 59.9h60.8v60.7H69.6Z" fill="none"/><path d="M100 110.5a20.2 20.2 0 1 0-20.2-20.3 20.3 20.3 0 0 0 20.2 20.3Z" fill="#fff" opacity=".3"/><path d="M100 115.5a25.3 25.3 0 1 0-25.3-25.3 25.3 25.3 0 0 0 25.3 25.3Zm0-45.5a20.2 20.2 0 1 1-20.2 20.2A20.3 20.3 0 0 1 100 70Zm-5 11v18.5a1 1 0 0 0 1.7.8l12.3-9.2a1 1 0 0 0 0-1.7l-12.3-9.2a1 1 0 0 0-1.8.8Z" fill="#fff"/></svg>',
  audioSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M46.8 37.8v124.4a7.7 7.7 0 0 0 7.6 7.8h91a7.7 7.7 0 0 0 7.8-7.6v-102L122.8 30H54.5a7.7 7.7 0 0 0-7.7 7.6Z" fill="#ee737a"/><path d="M66.3 142.5h3.6l6.3 16.8h-3.5l-1.4-4h-6.5l-1.3 4H60Zm4 10-1.5-4.3-.7-2H68l-.6 2-1.5 4.2Zm15 7.2a7.2 7.2 0 0 1-2.7-.5 5.6 5.6 0 0 1-2-1.4 6.4 6.4 0 0 1-1.4-2.2 8.8 8.8 0 0 1-.5-3v-10H82v10.2a5.4 5.4 0 0 0 .2 1.6 3.5 3.5 0 0 0 .6 1.2 3.1 3.1 0 0 0 1.1.8 3.4 3.4 0 0 0 1.5.3 3.5 3.5 0 0 0 1.4-.3 3 3 0 0 0 1-.8 3.5 3.5 0 0 0 .7-1.2 5.4 5.4 0 0 0 .2-1.6v-10.3h3.2v10.1a8.5 8.5 0 0 1-.5 3 6.3 6.3 0 0 1-1.3 2.2 5.8 5.8 0 0 1-2 1.4 6.8 6.8 0 0 1-2.7.5ZM96 142.5h5.7a9.9 9.9 0 0 1 3.6.6 7.8 7.8 0 0 1 2.7 1.8 7.5 7.5 0 0 1 1.7 2.6 10 10 0 0 1 0 6.9 7.5 7.5 0 0 1-1.7 2.6 7.9 7.9 0 0 1-2.7 1.7 9.9 9.9 0 0 1-3.6.6H96Zm5.5 13.8a7 7 0 0 0 2.5-.4 4.8 4.8 0 0 0 1.7-1 4.6 4.6 0 0 0 1.1-1.7 6.8 6.8 0 0 0 .4-2.3 6.7 6.7 0 0 0-.4-2.2 4.5 4.5 0 0 0-1-1.7 4.8 4.8 0 0 0-1.8-1 7.3 7.3 0 0 0-2.5-.5h-2.3v10.8Zm12.5-13.8h3.2v16.8H114Zm15.5 17.2a8.9 8.9 0 0 1-3.5-.7 8.5 8.5 0 0 1-4.6-4.7 9 9 0 0 1 1.8-9.6 8.5 8.5 0 0 1 2.8-1.9 9.3 9.3 0 0 1 7 0 8.5 8.5 0 0 1 2.8 1.9 8.8 8.8 0 0 1 1.8 2.8 9.3 9.3 0 0 1 0 6.8 8.8 8.8 0 0 1-1.8 2.8 8.7 8.7 0 0 1-2.8 1.9 9 9 0 0 1-3.5.7Zm0-3a5.7 5.7 0 0 0 2.2-.4 5.5 5.5 0 0 0 1.8-1.2 5.3 5.3 0 0 0 1.2-1.8 6.7 6.7 0 0 0 0-4.7 5.3 5.3 0 0 0-1.2-1.8 5.7 5.7 0 0 0-8 0 5.3 5.3 0 0 0-1.2 1.8 6.5 6.5 0 0 0 0 4.7 5.3 5.3 0 0 0 1.2 1.8 5.5 5.5 0 0 0 1.8 1.2 5.7 5.7 0 0 0 2.2.4Z" fill="#fff"/><path fill="#d3535a" d="M46.8 131.9h106.5v3.3H46.8zm106.4-71.4L122.8 30h-.2l-4.2 29.2a6.8 6.8 0 0 0 6.9 6.8l28-5.3Z"/><path d="M153.2 60.5h-25a5.5 5.5 0 0 1-5.4-5.5V30Z" fill="#fff" opacity=".8"/><path d="M69.6 58.3h60.8V119H69.6Z" fill="none"/><path d="M89.9 103.8a2.5 2.5 0 0 0 2.5-2.5V76a2.5 2.5 0 1 0-5 0v25.3a2.5 2.5 0 0 0 2.5 2.5ZM100 114a2.5 2.5 0 0 0 2.5-2.5V65.9a2.5 2.5 0 0 0-5 0v45.5a2.5 2.5 0 0 0 2.5 2.6ZM79.8 93.7a2.5 2.5 0 0 0 2.5-2.5v-5a2.5 2.5 0 0 0-5 0v5a2.5 2.5 0 0 0 2.5 2.5ZM110 104a2.5 2.5 0 0 0 2.6-2.6V76a2.5 2.5 0 1 0-5.1 0v25.3a2.5 2.5 0 0 0 2.5 2.5Zm7.6-17.8v5.1a2.5 2.5 0 0 0 5 0v-5a2.5 2.5 0 0 0-5 0Z" fill="#fff"/></svg>',
  heicSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200"><path d="M46.8 37.8v124.4a7.7 7.7 0 0 0 7.6 7.8h91a7.7 7.7 0 0 0 7.8-7.6v-102L122.8 30H54.5a7.7 7.7 0 0 0-7.7 7.6Z" fill="#5391ce"/><path d="M72.4 142.5h3.2v6.7h7v-6.7h3.2v16.8h-3.2v-7h-7v7h-3.2Zm21.1 3v4h6.8v3h-6.8v3.8h7.5v3H90.3v-16.8H101v3Zm11.6-3h3.2v16.8H105Zm22.2 14.1a8.3 8.3 0 0 1-3 2.3 8.8 8.8 0 0 1-3.7.8 9 9 0 0 1-3.5-.7 8.7 8.7 0 0 1-5.3-8 8.7 8.7 0 0 1 .7-3.5 8.5 8.5 0 0 1 4.6-4.7 8.8 8.8 0 0 1 3.5-.7 8.5 8.5 0 0 1 3.5.7 8.3 8.3 0 0 1 2.8 2l-2.3 2.2a5.8 5.8 0 0 0-1.7-1.4 4.8 4.8 0 0 0-2.3-.5 6 6 0 0 0-2.2.4 5.5 5.5 0 0 0-1.8 1.2 5.6 5.6 0 0 0-1.2 1.8 6.7 6.7 0 0 0 0 4.8 5.5 5.5 0 0 0 1.2 1.8 5.3 5.3 0 0 0 1.8 1.1 5.8 5.8 0 0 0 2.2.5 5.4 5.4 0 0 0 2.5-.6 6.3 6.3 0 0 0 1.9-1.6Z" fill="#fff"/><path fill="#3576b4" d="M46.8 131.9h106.5v3.3H46.8zm106.4-71.4L122.8 30h-.2l-4.2 29.2a6.8 6.8 0 0 0 6.9 6.8l28-5.3Z"/><path d="M153.2 60.5h-25a5.5 5.5 0 0 1-5.4-5.5V30Z" fill="#fff" opacity=".8"/><path d="M69.6 58.3h60.8V119H69.6Z" fill="none"/><path d="M82.3 106.4h35.4V71H82.3Z" fill="#fff" opacity=".3"/><path d="M117.7 65.9H82.3a5 5 0 0 0-5 5.1v35.4a5 5 0 0 0 5 5h35.4a5 5 0 0 0 5-5V71a5 5 0 0 0-5-5.1Zm-2.2 40.5h-31a2.2 2.2 0 0 1-2.2-2.2v-31a2.2 2.2 0 0 1 2.2-2.2h31a2.2 2.2 0 0 1 2.2 2.2v31a2.2 2.2 0 0 1-2.2 2.2Zm-11.8-15.8L97.8 98l-3.7-4.5a2.2 2.2 0 0 0-3.3 0l-4.6 6a1 1 0 0 0 .8 1.7h26a1 1 0 0 0 .9-1.7l-6.8-9a2.2 2.2 0 0 0-3.4 0Z" fill="#fff"/></svg>';

function getCanvasWithMainColor(image,request,canvasWidth,canvasHeight){
  var canvas = getCanvas(canvasWidth,canvasHeight);
  
  function writeRGB(){
    var result = "#";
    for(var i=0;i<arguments.length;i++){
      var r = arguments[i];
      if(r<16){
        result+="0";
      }
      result+=r.toString(16);
    }
    return result;
  }
  function getAverageRGB(imageData) {
    var r = 0,g = 0,b = 0,count = 0;
    for(var i=0;i<imageData.length;i+=4){
      r += imageData[i];
      g += imageData[i+1];
      b += imageData[i+2];
      count++;
    }
    return writeRGB(~~(r/count),~~(g/count),~~(b/count));
  }
  if(request.color===undefined){
    var 
      size = 8, //if we use 1 (writing an image in one pixel) it gave weirds results
      colorCanvas = getCanvas(size,size),
      ctx = colorCanvas.getContext("2d");
    
    ctx.drawImage(image, 0, 0, size, size);
    
    request.color = getAverageRGB(ctx.getImageData(0, 0, size, size).data) 
      
  }
  var ctx = canvas.getContext("2d");
  ctx.fillStyle = request.color;
  ctx.fillRect(0, 0, canvasWidth, canvasHeight);
  return canvas;
}




function getCanvas(canvasWidth,canvasHeight,title){
  var canvas = document.createElement("canvas");
  //document.body.appendChild(canvas);
  canvas.width = canvasWidth;
  canvas.height = canvasHeight;
  //canvas.style = "z-index:3000;position:absolute;top:50%;left:50%;";
  //canvas.title=title;
  return canvas;
}


function resizeImgVideoCanvas(image,request,success,error){
  //console.log(request.otientation,new Error())
  if(request.mode==="letterbox"){
    resizeImgVideoCanvasLetterbox(image,request,success,error)
  }else if(request.mode==="keepratio"){
    resizeImgVideoCanvasKeepRatio(image,request,success,error)
  }else{
    resizeImgVideoCanvasCrop(image,request,success,error)
  }
}
function resizeImgVideoCanvasLetterbox(image,request,success,error){
  console.log("resizeImgVideoCanvasLetterbox",arguments)
  var 
    width = request.width,
    height = request.height,
    ratioHeight = height / image.height,
    ratioWidth = width / image.width,
    originalRatio = image.width/image.height,
    targetRatio = width/height,
    canvas = getCanvasWithMainColor(image,request,width,height),
    ctx = canvas.getContext("2d");
  
  ctx.imageSmoothingQuality = "high";

  if (ratioHeight > ratioWidth) {
    //height must be letterboxed because the ratio is higher
    var  deltaHeight = Math.floor(ratioWidth*(image.width / targetRatio - image.height) / 2);
    ctx.drawImage(image, 0, 0, image.width, image.height, 0, deltaHeight, width, height-2*deltaHeight);
  } else {
    //width must be letterboxed because the ratio is higher
    var  deltaWidth = Math.floor(ratioHeight*(image.height * targetRatio - image.width) / 2);
    ctx.drawImage(image, 0, 0, image.width, image.height, deltaWidth, 0, width-2*deltaWidth, height);

  }
  buildResponse(canvas,request,success,error)
}
function resizeImgVideoCanvasCrop(image,request,success,error){
  console.log("resizeImgVideoCanvasCrop",arguments)
  var 
    width = request.width,
    height = request.height,
    ratioHeight = height / image.height,
    ratioWidth = width / image.width,
    originalRatio = image.width/image.height,
    targetRatio = width/height,
    canvas = getCanvas(width,height),
    ctx = canvas.getContext("2d");
  
  ctx.imageSmoothingQuality = "high";
  
  if (ratioHeight < ratioWidth) {
    //height must be crop because the ratio is smaller
    var  deltaHeight = Math.floor((image.width / targetRatio - image.height) / 2);
    ctx.drawImage(image, 0, -deltaHeight, image.width, image.height+ 2 *deltaHeight, 0, 0, width, height);
  } else {
    //width must be crop because the ratio is smaller
    var  deltaWidth = Math.floor((image.height * targetRatio - image.width) / 2);
    ctx.drawImage(image, -deltaWidth, 0, image.width + 2*deltaWidth, image.height, 0, 0, width, height);

  }
  buildResponse(canvas,request,success,error);
}
function resizeImgVideoCanvasKeepRatio(image,request,success,error){
  console.log("resizeImgVideoCanvasKeepRatio",arguments)
  var 
    ratioHeight = request.height / image.height,
    ratioWidth = request.width / image.width,
    targetRatio = Math.min(ratioHeight,ratioWidth),
    finalWidth = image.width*targetRatio,
    finalHeight = image.height*targetRatio,
    
    canvas = getCanvas(finalWidth,finalHeight),
    ctx = canvas.getContext("2d");
  
  ctx.imageSmoothingQuality = "high";
  ctx.drawImage(image, 0, 0, image.width, image.height, 0, 0, finalWidth, finalHeight);
  buildResponse(canvas,request,success,error);
}

function buildResponse(canvas,request,success,error){
  function respond(obj){
    if(obj instanceof HTMLCanvasElement){
      if(request.type==="canvas"){
        success(obj);
      }else if(request.type==="blob"){
        obj.toBlob(success, "image/jpeg");
      }else{
        success(obj.toDataURL("image/jpeg"));
      }  
    }else if(obj instanceof String){
      if(request.type==="canvas"){
        //TODO code this
        error();
      }else if(request.type==="blob"){
        //TODO code this
        error();
      }else{
        success(obj);
      }  
      
    }
    
  }
  
  if(request.addsvg){
    var 
      img = document.createElement("img"),
      svg = request.addsvg;
    
    img.crossOrigin = "Anonymous";
    img.onload = function(){
      var ctx = canvas.getContext("2d");
      ctx.imageSmoothingQuality = "high";
      ctx.drawImage(this, 0 , 0, canvas.width, canvas.height);
      respond(canvas);
    }
    img.onerror = error;
    img.src = "data:image/svg+xml;base64,"+btoa(svg.replace("currentColor",FizConfig.defaultColor));
    
  }else{
    respond(canvas);
  }
}

function cropBlackBorder(image,request,success,error){
  console.log("cropBlackBorder",arguments)
  
  //detect if a pixel is worth ignoring
  function ignore(data,pixIdx,log){
    var idx = 4* pixIdx;
    if(log) console.log(idx,data[idx],data[idx+1],data[idx+2],data[idx+3])
    //transparent
    if(data[idx+3]===0) return true;
    //black
    if(data[idx]<16 && data[idx+1]<16 && data[idx+2]<16) return true;
    return false;
  }

  
  var 
    originalWidth = image.width,
    originalHeight = image.height,
    //we want a well sized canvas according to the targeted resolution, we make *2 because cropping will remove some resolution, but increasing resolution never give good images
    ratio = Math.min(1,2*Math.max(request.width/originalWidth,request.height/originalHeight)),
    width = Math.floor(originalWidth*ratio),
    height = Math.floor(originalHeight*ratio),
    canvas = getCanvas(width,height,"forcrop"),
    ctx = canvas.getContext("2d");
  
  ctx.drawImage(image,0,0,width,height);
  
  
  var 
    data = ctx.getImageData(0,0, width,height).data,
    middleLineStart = Math.floor(height/2)*width,
    middleHeightDelta = Math.floor(width/2),
    startWidth=0,endWidth=width,
    startHeight=0,endHeight=height,
    change = false;
  
  for(let i=0;i<width/3;i++){
    if(ignore(data,middleLineStart+i)){
      startWidth = i+2;
      change = true;
    }else{
      break;
    }
  }
  for(let i=(width-1);i>=2*width/3;i--){
    if(ignore(data,middleLineStart+i)){
      endWidth = i-2;
      change = true;
    }else{
      break;
    }
  }
  for(let i=0;i<height/3;i++){
    if(ignore(data,(width*i)+middleHeightDelta)){
      startHeight = i+2;
      change = true;
    }else{
      break;
    }
  }
  for(let i=(height-1);i>2*height/3;i--){
    if(ignore(data,(width*i)+middleHeightDelta)){
      endHeight = i-2;
      change = true;
    }else{
      break;
    }
  }
  if(change){
    var 
      cropedWidth = endWidth-startWidth,
      cropedHeight = endHeight-startHeight,
      cropcanvas = getCanvas(cropedWidth,cropedHeight,"cropped"),
      cropContext = cropcanvas.getContext("2d");
    
    cropContext.drawImage(canvas,startWidth,startHeight,cropedWidth,cropedHeight,0,0,cropedWidth,cropedHeight);
    resizeImgVideoCanvas(cropcanvas,request,success,error)  
  }else{
    resizeImgVideoCanvas(canvas,request,success,error)  
  }
  
  
}


function cropBlackBorderByUrl(url,request,success,error){
  console.log("cropBlackBorderByUrl",arguments)
  var 
    img = document.createElement("img");
  img.crossOrigin = "Anonymous";
  img.onload = function(){
    if(request.ontoosmall && (this.width<request.width || this.height<request.height)){
      request.ontoosmall();
      return;
    }
    cropBlackBorder(this,request,success,error)
  }
  img.onerror = error;
  img.src = url;
}


  

function extractJpegThumb(file,request,success,error){
  console.log("extractJpegThumb",arguments)
  loadImage.parseMetaData (file,function(data){
    var thumb;
    console.log(data)
    if(data.exif){
      request.orientation = data.exif.get('Orientation');
      thumb = data.exif.Thumbnail; 
    }
    if(thumb){
      cropBlackBorderByUrl(thumb,request,success,function(err){
        //if the thumb is corrupted we try with the whole file
        createThumb(file,request,success,error);
      });
    }else{
      createThumb(file,request,success,error);
    }
  });
  
}

function useVideoIcon(file,request,success,error){
  console.log("useVideoIcon",arguments)
  success("data:image/svg+xml;base64,"+btoa(videoSvg))
}
function useAudioIcon(file,request,success,error){
  console.log("useAudioIcon",arguments)
  success("data:image/svg+xml;base64,"+btoa(audioSvg))
}
function useHeicIcon(file,request,success,error){
  console.log("useHeicIcon",arguments)
  success("data:image/svg+xml;base64,"+btoa(heicSvg))
}

function extractVideoThumb(file,request,success,error){
  console.log("extractVideoThumb",arguments)
  var reader = new FileReader();
  reader.onload = function (e) {
    var array = new Uint8Array(e.target.result), start, end;
    for (var i = 2; i < array.length; i++) {
      if (array[i] === 0xFF) {
        if (!start) {
          if (array[i + 1] === 0xD8) {
             start = i;
          }
        } else {
          if (array[i + 1] === 0xD9) {
            //if too small it is not a jpeg
            if(i-start<500){
              start = undefined;
            }else{
              end = i;
              break;  
            }
            
          }
        }
      }
    }
    if (start && end) {
      request.addsvg=videoSvg;
      cropBlackBorderByUrl(URL.createObjectURL(new Blob([array.subarray(start, end)], {type:"image/jpeg"})),request,success,error);
    }else{
      useVideoIcon(file,request,success,error)
    }
  };
  reader.readAsArrayBuffer(file.slice(0,100000));
  
}

function extractJpegRawExif(file,request,success,error){
  console.log("extractJpegRawExif",arguments)
  var reader = new FileReader();
  reader.onload = function (e) {
    var array = new Uint8Array(e.target.result), start, end;
    for (var i = 2; i < array.length; i++) {
      if (array[i] === 0xFF) {
        if (!start) {
          if (array[i + 1] === 0xD8) {
             start = i;
          }
        } else {
          if (array[i + 1] === 0xD9) {
            //if too small it is not a jpeg
            if(i-start<500){
              start = undefined;
            }else{
              end = i;
              break;  
            }
            
          }
        }
      }
    }
    if (start && end) {
      request.addsvg=videoSvg;
      cropBlackBorderByUrl(URL.createObjectURL(new Blob([array.subarray(start, end)], {type:"image/jpeg"})),request,success,error);
    }else{
      error();
    }
  };
  reader.readAsArrayBuffer(file.slice(0,100000));
}


function createVideoThumb(file,request,success,error){
  console.log("createVideoThumb",arguments)
  var 
    video = document.createElement("video");
  video.crossOrigin = "Anonymous";
  video.onerror = error;
  video.onloadedmetadata = function(){
    request.addsvg=videoSvg;
    video.width=video.videoWidth;
    video.height=video.videoHeight;
    video.ontimeupdate= function() {
      resizeImgVideoCanvasCrop(video,request,success,error)
    }
    if(video.duration>3){
      video.currentTime=2;  
    }else{
      video.currentTime=0.5;
    }
  };

  video.src = URL.createObjectURL(file);
}  

function extractSvg(file,request,success,error){
  success(URL.createObjectURL(file));
}

function createThumb(file,request,success,error){
  console.log("createThumb",arguments)
  var 
    img = document.createElement("img");
  img.crossOrigin = "Anonymous";
  img.onload = function(){
    resizeImgVideoCanvas(this,request,success,error)
  }
  img.onerror = error;
  img.src = typeof file ==='string'?file:URL.createObjectURL(file);
}


function thumbnail(image,request,success,error){
  request.mode = request.mode===undefined?"crop":request.mode;
  console.log("thumbnail",arguments);
  //TODO add test for Video
  if(image instanceof Image || image instanceof HTMLCanvasElement){
    resizeImgVideoCanvas(image,request,success,error);
  }else if(image instanceof File){
    if(image.type==="image/svg+xml"){
      success(URL.createObjectURL(image));
    }else if(image.type==="image/jpeg"){
      request.ontoosmall = function(){
        request.ontoosmall = undefined;
        createThumb(image,request,success,error)
      }
      extractJpegThumb(image,request,success,error);
    }else if(image.type.indexOf("video")===0){
      createVideoThumb(image,request,success,function(){
        extractVideoThumb(image,request,success,function(){
          useVideoIcon(image,request,success,error);
        });
      });
    }else if(image.type.indexOf("audio")===0){
      useAudioIcon(image,request,success,error);
    }else if(image.name.endsWith(".heic")){
      useHeicIcon(image,request,success,error);
    }else{
      createThumb(image,request,success,error);
    }
  //if it is a string how to know it is a video or an image url?
  }else if(typeof image ==='string'){
    createThumb(image,request,success,error);
  }
}

function downsize(image,request,success,error){
  //for wrapping all callback with error handler
  function wrapper(func){
    return function(){
      try{
        return func.apply(this,arguments)
      }catch(e){
        error(e);
      }  
    }
  }
  
  request.mode = request.mode===undefined?"keepratio":request.mode;
  request.type = request.type===undefined?"blob":request.type;
  request.keepMetadata = request.keepMetadata===undefined?true:request.keepMetadata;
  
  console.log("downsize",arguments)
  //TODO add test for Video
  if(image instanceof Image || image instanceof HTMLCanvasElement){
    resizeImgVideoCanvas(image,request,success,error);
  }else if(image instanceof File){
    if(image.type==="image/svg+xml"){
      success(image);
    }else if(image.type.indexOf("image/jpeg")===0){
      loadImage(
          image,
          wrapper(function(canvas,data){
            canvas.toBlob(wrapper(function(blobResized){
              if (!data.imageHead) {
                success(blobResized);
              }else{
                try{
                  loadImage.writeExifData(data.imageHead, data, 'Orientation', 1)
                }catch(e){
                  //FIXME it happens all the times what happenned ??!!! 
                  console.log(e)
                }
                // Combine data.imageHead with the image body of a resized file
                // to create scaled images with the original image meta data, e.g.:
                success(
                    new File([new Blob([data.imageHead,loadImage.blobSlice.call(blobResized, 20)], {type: blobResized.type})],image.name)
                );
              }
            }), "image/jpeg", 0.9);
          }),{
            maxWidth: request.width,
            maxHeight: request.height,
            canvas: true,
            meta:true,
            maxMetaDataSize: 262144,
            disableImageHead: false
          }
       );
      

    }else{
      error(new Error('cannot downsize not jpg'));
    }
  //if it is a string how to know if it is a video or an image url?
  }else if(typeof image ==='string'){
    createThumb(image,request,success,error);
  }
}


